<template>
   <button
      class="submit-products-btn btn btn-secondary btn-lg"
      :class="{
         'enabled': productCount > 0,
         'pulse-dark': pulseDark,
         'btn-rounded-pill': !old,
         'old': old,
      }"
      :title="productCount > 0 ? 'Indhent tilbud' : 'Du skal vælge mindst én forsikringstype'"
      type="button"
      @click="submit">
      <div>Indhent tilbud</div>
   </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'SubmitProductsButton',
   props: {
      pulseDark: {
         type: Boolean,
         default: false,
      },
      wrapper: {
         type: String,
         required: true,
      },
      old: {
         type: Boolean,
         default: false,
      },
   },
   computed: {
      ...mapGetters(['productCount', 'formUrl']),
   },
   methods: {
      submit(e) {
         e.stopImmediatePropagation();
         // Ignore click if guide is active
         // Redirect if products are selected
         if (this.productCount > 0) {
            e.stopImmediatePropagation();
            document.location.href = this.formUrl;
            return;
         }
         window.tour.start(this.wrapper);
      },
   },
};
</script>

<style lang="scss" scoped>
.submit-products-btn {
   position: relative;
   //box-shadow: none;
   transition: box-shadow 0.3s;
   margin: 20px auto 10px auto !important;
   color: #fff;
   width: 158px;
   height: 50px;

   cursor: pointer;
   display: block;

   &:not(.old) {
      border: 1px solid rgba(255, 255, 255, 0.4);
      font-size: 20px;
   }
   &.old {
      font-size: 15px;
      border-radius: 4px;
   }

   div {
      transition: transform 0.3s;
   }

   small {
      text-transform: none;
   }

   &.enabled {
      animation: pulse-light 2s infinite;
      &.pulse-dark {
         animation: pulse-dark 2s infinite;
      }
      &.old {
         animation: pulse-orange 2s infinite;
      }

      &:hover {
         animation: none;
      }
   }
}

@keyframes pulse-light {
   0% {
      -moz-box-shadow: 0 0 0 0 rgba(36, 53, 67, 1);
      box-shadow: 0 0 0 0 rgba(36, 53, 67, 1);
   }
   70% {
      -moz-box-shadow: 0 0 0 10px rgba(36, 53, 67, 0);
      box-shadow: 0 0 0 10px rgba(36, 53, 67, 0);
   }
   100% {
      -moz-box-shadow: 0 0 0 0 rgba(36, 53, 67, 0);
      box-shadow: 0 0 0 0 rgba(36, 53, 67, 0);
   }
}

@keyframes pulse-dark {
   0% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
   }
   70% {
      -moz-box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
   }
   100% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
   }
}

@keyframes pulse-orange {
   0% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 150, 15, 1);
      box-shadow: 0 0 0 0 rgba(254, 150, 15, 1);
   }
   70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 150, 15, 0);
      box-shadow: 0 0 0 10px rgba(254, 150, 15, 0);
   }
   100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 150, 15, 0);
      box-shadow: 0 0 0 0 rgba(254, 150, 15, 0);
   }
}
</style>
